import type {ConnectElementConfig} from '../../../connect/ConnectJSInterface/ConnectElementList';

export const InstantPayoutsPromotionConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "instantPayoutsPromotion" */
      '../../../components/InstantPayoutsPromotion/InstantPayoutsPromotion'
    ),
  enabledKey: 'internal', // TODO: Change to 'instant_payouts_promotion' after account session API update
  htmlEvents: ['oninstantpayoutseligibilityloaded', 'instantpayoutcreated'],
  customHtmlElementMethods: {
    setOnInstantPayoutsEligibilityLoaded: {
      type: 'EventListenerMethod',
      event: 'oninstantpayoutseligibilityloaded',
      isInternal: true,
      description:
        'Sets the event listener that allows a user to pass in a callback function for when the promotion is loaded.',
    },
    setOnInstantPayoutCreated: {
      type: 'EventListenerMethod',
      event: 'instantpayoutcreated',
      isInternal: true,
      description:
        'Sets the event listener that allows a user to pass in a callback function for when an instant payout is created.',
    },
  },
  releaseState: 'internal',
  sentryTeam: 'accounts_ui',
  teamOwner: 'connected-account-experiences-eng',
  description:
    'Displays promotional banner to encourage using instant payouts, along with a button to perform instant payouts.',
};
